"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIRTUAL_CATEGORIES = exports.ROOM_TYPES = exports.QUICKACTIONS_CATEGORIES = exports.NOTIFICATIONS_LIMIT = exports.CATEGORIES = void 0;
var CATEGORIES = exports.CATEGORIES = {
  ROOM: 'room',
  CONTACT: 'contact',
  MEMBER: 'member'
};
var NOTIFICATIONS_LIMIT = exports.NOTIFICATIONS_LIMIT = 20;
var QUICKACTIONS_CATEGORIES = exports.QUICKACTIONS_CATEGORIES = [CATEGORIES.CONTACT, CATEGORIES.MEMBER];
var ROOM_TYPES = exports.ROOM_TYPES = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  TAKEOFF: 'takeoff',
  MISSED: 'missed',
  HANGUP: 'hangup'
};
var VIRTUAL_CATEGORIES = exports.VIRTUAL_CATEGORIES = {
  QUICKACTIONS: 'quickActions'
};